import React from 'react';
import TextProcessor from "@/components/common/TextProcessor";
import Image from "next/image";
import { type Block } from "@/sections/SectionRenderer";

interface ContactBannerData extends Block {
  image: {
    src: string;
    alt: string;
  };
  title: string;
  description: string;
  paragraph: string;
  ctaText: string;
  ctaLink: string;
}

export const ContactBanner: React.FC<{ data: ContactBannerData }> = ({ data }) => {
  const { id, image, description, paragraph, ctaText, ctaLink } = data;

  // Always render both variants via dark: so no re-compute after hydrate.
  const imageShadowClass = `shadow-lg drop-shadow-pinkblue dark:drop-shadow-purpleright`;

  return (
    <section className="bg-card" id={id}>
      <div
        className="z-10 text-2xl font-light mx-4 lg:mx-32 sm:px-6 lg:px-8 py-12 lg:py-16 flex flex-col lg:flex-row items-center">
        <div className="z-0 lg:w-1/2 mb-8 lg:mb-0">
          <Image 
            unoptimized 
            width={996} 
            height={602} 
            src="/assets/contact.png" 
            alt={image.alt}
            className={`rounded-lg shadow-xl ${imageShadowClass}`} 
          />
        </div>
        <div className="z-10 px-2 sm:px-0 lg:w-1/2 lg:pl-12">
          <div className="text-primary mb-6">
            <TextProcessor>
              {description}
            </TextProcessor>
          </div>
          <span className="text-primary mb-6">
            <TextProcessor>
              {paragraph}
            </TextProcessor>
          </span>
          <p>
            <a
              href={ctaLink}
              className="font-semibold text-accent underline"
            >
              {ctaText}
            </a> and we will get back to you as soon as possible!
          </p>
        </div>
      </div>
    </section>
  );
};
